module.exports = __webpack_public_path__ + "static/media/Golden.37133aa9.jpeg";